export default ({ COLORS, FONT_SIZES }) => ({
  container: {
    display: 'flex',
    height: '190px',
    padding: '22px',
    margin: '-22px -22px -22px',
    borderBottom: '1px solid #dedede',
    justifyContent: 'center',
    position: 'relative'
  },
  backLink: {
    position: 'absolute',
    left: '22px',
    top: '22px',
    color: COLORS.BLUE.NORMAL,
    fontSize: '14px',
    lineHeight: '16px',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none'
  },
  avatar: {
    margin: '0 0 10px'
  },
  names: {
    textAlign: 'center',
    '& strong': {
      display: 'block',
      fontSize: '22px',
      lineHeight: '22px',
      fontWeight: 'normal',
      color: COLORS.TEXT.MID_GREY.NORMAL
    },
    '& span': {
      fontSize: '18px',
      lineHeight: '18px',
      color: COLORS.TEXT.LIGHT_GREY.NORMAL
    }
  },
  studentInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > *': {
      flexShrink: '0'
    }
  }
})
